<div id="map"></div>

<div class="map-loading" *ngIf="isLoading">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div class="map-overlay">
  <app-catch-filter-panel 
    [showAnglerNotes]="false" 
    [showHeatmapToggle]="true"
    [heatMap]="heatMap"
    (filterChange)="onFilterChange($event)"
    (heatmapToggleChange)="onHeatmapToggle($event)">
  </app-catch-filter-panel>
</div>
